export default __webpack_public_path__ + "static/media/volume.941a1bad.svg";